var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleEngagementIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.182 5.14732C14.8694 4.78706 14.4831 4.49817 14.0491 4.30022C13.6151 4.10228 13.1437 3.99989 12.6667 3.99999H10.0074L10.2314 2.63932C10.3106 2.16016 10.215 1.66848 9.96195 1.25395C9.70889 0.839416 9.31525 0.529662 8.85284 0.381182C8.39042 0.232701 7.89004 0.255388 7.44296 0.445104C6.99588 0.63482 6.63188 0.978924 6.41737 1.41465L5.33337 3.61132V14H12.2C13.0023 13.9967 13.7768 13.7055 14.3826 13.1794C14.9883 12.6533 15.3851 11.9273 15.5007 11.1333L15.9707 7.79999C16.0372 7.32714 16.0011 6.84552 15.8651 6.38783C15.729 5.93013 15.496 5.50706 15.182 5.14732Z",
    fill: "#1E7C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.33333V10.6667C0.00105857 11.5504 0.352588 12.3976 0.97748 13.0225C1.60237 13.6474 2.4496 13.9989 3.33333 14H4V4H3.33333C2.4496 4.00106 1.60237 4.35259 0.97748 4.97748C0.352588 5.60237 0.00105857 6.4496 0 7.33333H0Z",
    fill: "#1E7C88"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleEngagementIcon);
export default __webpack_public_path__ + "static/media/peopleEngagementIcon.9eb782d9f93ed750053f2ffbfcdac97d.svg";
export { ForwardRef as ReactComponent };